module.exports = __webpack_public_path__ + "static/media/print-footer-bg.d9047ba8.png";